import {
  POPULATE_VEHICLE_SEARCH_PARAMS,
  POPULATE_VEHICLE_COUNT,
  POPULATE_VEHICLES,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case POPULATE_VEHICLE_SEARCH_PARAMS:
      return {
        ...state,
        vehicleSearchParams: { ...state.vehicleSearchParams, ...action.payload },
      };
    case POPULATE_VEHICLES:
      return {
        ...state,
        vehicles: action.payload,
      };
    case POPULATE_VEHICLE_COUNT:
      return {
        ...state,
        vehicleCount: action.payload,
      };
    default:
      return state;
  }
};
